import {useRef, useState} from 'react';

export default function MatrixVideoField(content, i) {
    const video = useRef(null);
    const [videoIsPlaying, setVideoIsPlaying] = useState(false)
    if (!content?.content) {
        return <></>
    }

    const videoController = (el) => {
        if (el.current.paused) {
            el.current.play();
            setVideoIsPlaying(true);
            return;
        }
        el.current.pause();
        setVideoIsPlaying(false);
    }

    return (
        <section className={'relative lg:max-w-5xl my-10 md:my-20'} key={i}>
            <div className={'cursor-pointer'} onClick={() => videoController(video)}>
                <div className={`duration-200 ${videoIsPlaying && 'opacity-0 pointer-events-none'}`}>
                    <img src={'/assets/icon/playbutton.svg'} width="80" height="80"
                         className={'absolute m-auto left-0 right-0 top-0 bottom-0 z-20'}/>
                    <div className={'absolute w-full h-full bg-black/25 z-10'}></div>
                </div>
            </div>
            <video className={'w-full object-cover'} ref={video} controls={videoIsPlaying} poster={content?.content?.image_1?.url}>
                <source
                    src={content?.content?.video?.url}/>
            </video>
        </section>
    );
}
